export default "__VITE_ASSET__k7D8z8oB__"